export enum TextTrackEvent {
    CUE_CHANGE = 'cuechange',
    ADD_TRACK = 'addtrack',
    CHANGE = 'change'
}
